import { ICommission, IProduct } from './../../models/commission';

export class Commission implements ICommission {
  public ComissionId: string = '';
  public Code: number = 0;
  public ProductsComission: IProduct[] = [
    {
      ProductId: 'produto',
      ComissionId: '',
      BankId: '',
      CompanyId: '',
      ProductComissionId: '',
      Period: '',
      CommissionType: 2,
      MaxCommissionPerContract: 0,
      Productions: [
        {
          InitialProduction: 0,
          FinalProduction: 0,
          Percentage: 0,
          InvoiceValue: 0,
          TransferValue: 0,
          ProductionID: ''
        }
      ]
    }
  ];
}
